<template>
  <v-layout row>
    <v-flex xs12 style="position:relative;" class="edit-textfield">
      <v-textarea auto-grow rows="1" class="text-hiding" v-model="outputFormula" :label="label" :rules="rules">
      </v-textarea>
      <span class="text-in-color">
        <span class="text-in-color-item" v-for="(item,index) in items" :style="{color:styleLookUp[item.type]}" :key="index">{{item.value}}</span>
      </span>
      <v-textarea auto-grow rows="1" class="textfield-placeholder" :label="label" v-model="outputFormula"></v-textarea>
    </v-flex>
    <v-menu v-model="menu" :close-on-content-click="false" :close-on-click="false" offset-y left>
      <template v-slot:activator="{ on }">
        <v-btn v-if="useMenu" icon v-on="on">
          <v-icon>info</v-icon>
        </v-btn>
      </template>
      <v-card width="500">
        <v-card-text>
          <div>{{menuTitle}}</div><br>
          <div><b>{{Double}}: </b>{{DoubleData}}</div>
          <div><b>{{Equation}}: </b>{{EquationData}}</div>
          <div><b>{{Range}}: </b>{{RangeData}}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small outline color="secondary" @click="menu = false">{{$t('Button.Close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-layout>
</template>
<script>
  import TestFormula from '@/components/generic/TestFormula'
  import {
    SPLIT_REGEX,
    NUMBER_REGEX,
    OPERATOR_REGEX,
    PARAMETER_REGEX,
  } from '@/helpers/regex'

  export default {
    model: {
      prop: 'inputFormula',
      event: 'formulaEdit',
    },
    components: {
      TestFormula,
    },
    props: {
      label: {
        type: String,
        default: '',
      },
      inputFormula: {
        type: String,
        default: '',
      },
      rules: {
        type: Array,
        default: () => [],
      },
      useMenu: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        styleLookUp: {
          'number': 'green',
          'operator': 'orange',
          'parameter': 'blue',
          'normal': 'black',
        },
        outputFormula: '',
        menu: false,
        menuTitle: 'Guideline values can take the form of a static double value, an equation,or a range. Here are examples of how to define guideline for each of the guideline types:',
        Double: 'Double',
        DoubleData: '21.4',
        Equation: 'Equation',
        EquationData: 'Log([Hardness (as CaCO3)|mg/L], [Math.E]) + 1.23',
        Range: 'Range',
        RangeData: '6.5<=[PH|pH] and [PH|pH]<=9',
        FormulaList: [],
      }
    },
    mounted() {
      this.outputFormula = this.inputFormula
    },
    computed: {
      items() {
        if (!this.outputFormula) return []
        var arr = this.outputFormula.match(SPLIT_REGEX)
        if (arr != null) {
          var list = arr.map(x => this.textType(x))
          this.FormulaList = list
          return list
        }
        return []
      },
    },
    watch: {
      outputFormula() {
        this.$emit('formulaEdit', this.outputFormula)
      },
      inputFormula() {
        this.outputFormula = this.inputFormula
      },
      FormulaList() {
        this.$emit('formulaList', this.FormulaList)
      },
    },
    methods: {
      textType(item) {
        var result = {
          type: 'normal',
          value: item,
        }
        if (NUMBER_REGEX.test(item)) {
          result.type = 'number'
        } else if (PARAMETER_REGEX.test(item)) {
          result.type = 'parameter'
        } else if (OPERATOR_REGEX.test(item)) {
          result.type = 'operator'
        } else {
          result.type = 'normal'
        }
        return result
      },
    },
  }
</script>
<style scoped>
  .text-hiding {
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  .text-in-color {
    position: absolute;
    z-index: 2;
  }

  .text-in-color-item {
    position: relative;
    font-size: 1.14rem;
    top: 1.44rem;
  }

  .textfield-placeholder {
    opacity: 0;
    z-index: -1;
  }

  .edit-textfield>>>.v-input__slot>div>textarea {
    color: rgba(0, 0, 0, 0);
    font-size: 1.14rem;
    line-height: 21px;
  }
</style>